import { useCallback, useMemo } from 'react';
import { parseJSON } from '@helpers/data';
import ConfigContext from './context';

// To extend add to ReactContextProvider.php
function ConfigProvider({ context, children, config = {} }) {
    const {
        controller,
        dataCookie,
        deviceType,
        env,
        features,
        href,
        imageDimensions,
        productCardImageDimensions,
        trackingPageViewUrl,
        imageResizeUrl,
        language,
        localImageSrc,
        location,
        pathname,
        routes,
        serverSide,
        settings,
        store,
        stores,
        SVGURL,
        SVGPath,
        URLPrefix,
        colorSwatches,
        isMobileDevice,
        imagesStaticUrl,
        userAgent,
        webshop = {
            id: 'boozt',
            theme: 'theme-boozt'
        },
        isApp,
        trackingData,
        navGender,
        locale,
        stylitics,
        styleFlex
    } = context;

    const isActiveFeature = useCallback((name) => {
        const featureList = features ?? App.Config.activeFeatures;

        return featureList.includes(name);
    }, [features]);

    const value = useMemo(() => ({
        controller,
        dataCookie,
        deviceType,
        env,
        features,
        href,
        imageDimensions,
        productCardImageDimensions,
        trackingPageViewUrl,
        imageResizeUrl,
        language,
        localImageSrc: parseJSON(localImageSrc),
        location,
        pathname,
        routes,
        serverSide,
        settings,
        store,
        stores,
        SVGURL,
        URLPrefix,
        SVGPath,
        isActiveFeature,
        colorSwatches,
        userAgent,
        webshop,
        isMobileDevice,
        imagesStaticUrl,
        isApp,
        trackingData,
        navGender,
        locale,
        stylitics,
        styleFlex,
        ...config
    }), [controller, dataCookie, deviceType, env, features, href, imageDimensions,
        productCardImageDimensions, imageResizeUrl, language, localImageSrc, location,
        pathname, routes, serverSide, settings, store, stores, SVGURL, URLPrefix, SVGPath, isActiveFeature,
        colorSwatches, userAgent, webshop, isMobileDevice, imagesStaticUrl, isApp, trackingData,
        navGender, locale, stylitics, styleFlex, trackingPageViewUrl, config]);

    return <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>;
}

export default ConfigProvider;
